module.exports = __webpack_public_path__ + "static/media/email.b59ebbf8.svg";